import { render, staticRenderFns } from "./Malzeme.vue?vue&type=template&id=15654c61&scoped=true&"
import script from "./Malzeme.vue?vue&type=script&lang=js&"
export * from "./Malzeme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15654c61",
  null
  
)

export default component.exports